<template>
    <b-form-row>
        <b-col>
            <label>Customer Assets</label>
            <b-form-select
                :select-size="6"
                id="input-all-assets"
                name="input-all-assets"
                size="sm"
                v-model="markedUnit"
                :options="allAssetsOptions"
            >
            </b-form-select>
        </b-col>
        <b-col cols="2">
            <div>
                <label></label>
                <br /><br />
                <b-button
                    :disabled="!markedUnit"
                    size="sm"
                    variant="primary"
                    block
                    @click="addAsset"
                    >Add Asset</b-button
                >
                <b-button
                    :disabled="!selectedUnit"
                    size="sm"
                    variant="warning"
                    block
                    @click="removeAsset"
                    >Remove Asset</b-button
                >
            </div>
        </b-col>
        <b-col>
            <label>Assigned Assets</label>
            <b-form-select
                id="input-selected-assets"
                :select-size="6"
                name="input-selected-assets"
                size="sm"
                v-model="selectedUnit"
                :options="selectedAssetsModel"
            >
            </b-form-select>
        </b-col>
    </b-form-row>
</template>

<script>
export default {
    name: 'ViewAssets',
    props: ['value', 'customerId'],
    data() {
        return {
            selectedUnit: null,
            markedUnit: null,
            selectedAssets: [],
        }
    },

    methods: {
        addAsset() {
            const alreadyExits = !!this.selectedAssets.find(
                x => x.id === this.markedUnit
            )
            if (!alreadyExits) {
                const unit = this.customerAssets.find(
                    x => x.id === this.markedUnit
                )
                this.selectedAssets.push(unit)
            }
            this.markedUnit = null
            this.$emit(
                'input',
                this.selectedAssets.map(x => x.id)
            )
        },
        removeAsset() {
            const idx = this.selectedAssets.findIndex(
                x => x.id === this.selectedUnit
            )
            this.selectedAssets.splice(idx, 1)
            this.selectedUnit = null
            this.$emit(
                'input',
                this.selectedAssets.map(x => x.id)
            )
        },
    },
    watch: {
        value: {
            handler: function (_assets) {
                const self = this
                console.log('value', _assets)
                console.log('customerAssets', self.customerAssets)
                this.selectedAssets = _assets.map(x =>
                    self.customerAssets.find(y => y.id === x)
                )
            },
            deep: true,
        },
    },

    computed: {
        customerAssets() {
            return this.$store.state.assets.assets.filter(
                x => x.customer_id === this.customerId
            )
        },
        allAssetsOptions() {
            return this.customerAssets.map(x => ({
                value: x.id,
                text: x.name + ' ' + x.serial_no,
            }))
        },
        selectedAssetsModel() {
            console.log('selectedAssets', this.selectedAssets)
            return this.selectedAssets.map(x => ({
                value: x.id,
                text: x.name + ' ' + x.serial_no,
            }))
        },
    },
}
</script>
<style scoped>
.center {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    border: 3px solid green;
}
</style>